import mutations from "./../mutations";
import axios from 'axios'
import router from './../../router'
import uri from './../config'


const { SET_USERS, UPDATE_USER_PASSWORD, USER_UPDATE } = mutations;

const userStore = {
    state: {
        users: [],
    },
    getters: {
        get_users: ({ users }) => users,
        get_user_by_id: ({ users }) => id => users.find(user => user.id == id)
    },
    mutations: {
        [SET_USERS](state, payload) {
            state.users = payload;
        },
        [UPDATE_USER_PASSWORD](state, payload) {
            const user = state.users.find(user => user._id == payload.user_id)
            user.show_password = payload.show_password

        },
        [USER_UPDATE](state, payload) {
            state.users.forEach(n => {
                if (n._id == payload.user._id) {
                    n.title = payload.user.title
                    n.status = payload.user.status
                    n.name = payload.user.name
                }
            });

        }
    },
    actions: {
        async load_users({ commit }) {

            const instance = await axios.create({
                baseURL: uri,
                headers: {
                    "Content-Type": "application/json",
                    "X-token": localStorage.getItem("_token"),
                    "title": localStorage.getItem("title"),
                    "_id": localStorage.getItem("_id"),
                },
            });

            instance
                .get('/users')
                .then(r => r.data)
                .then(data => {

                    commit(SET_USERS, data.users)
                }).catch(err => {
                    if (err.response.status == 401)
                        router.push("/statistic")
                })
        },

        async update_password({ commit }, data) {

            console.log(commit);
            const instance = await axios.create({
                baseURL: uri,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${data}`
                },
            });

            instance
                .put(`/users/edit_password/${data.user_id}`, { password: data.password, show_password: data.show_password })
                .then(r => r.data)
                .then(res => {

                    commit(UPDATE_USER_PASSWORD, { user_id: data.user_id, show_password: data.show_password })
                })


            return false
        },

        async update_user({ commit }, data) {

            console.log(data);
            const instance = await axios.create({
                baseURL: uri,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${data}`
                },
            });

            instance
                .put(`/users/${data.user._id}`, data)
                .then(r => r.data)
                .then(res => {

                    commit(USER_UPDATE, { user: data.user })
                })


            return false
        },
    }
};

export default userStore;